export default "__VITE_ASSET__35907e3c__"